<template>
  <v-layout row justify-center>
    <v-dialog v-model="showNewTrainingDialog" max-width="98%"
      transition="dialog-bottom-transition" @keydown.esc="showNewTrainingDialog = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">
            Adicionar Treino
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showNewTrainingDialog = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="text-xs-center" v-show="!trainingType">
            <v-btn round large depressed color="success"
              @click="toggleNewOrByTemplate('template')">
              Criar a partir de um modelo
            </v-btn>
            <br>
            <v-btn round large depressed color="success" @click="toggleNewOrByTemplate('new')">
              Novo treino
            </v-btn>
          </div>
          <new-training v-show="trainingType == 'new'" :user="user"></new-training>
          <div class="training-list" v-show="trainingType == 'template'">
            <v-flex xs12>
              <v-text-field v-model="search" class="search-input" placeholder="Procurar treino...."
                append-icon="fal fa-search" hide-details></v-text-field>
            </v-flex>
            <br>
            <v-layout class="training-item" row wrap align-center justify-center
              v-for="(training, index) in filteredTrainings" :key="index">
              <v-flex xs10>
                {{ training.name }}
              </v-flex>
              <v-flex xs2 class="text-xs-right">
                <v-btn flat small color="teal" @click="selectTraining(training)">
                  <v-icon>fal fa-chevron-square-right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus'
import axios from 'axios'
import NewTrainingComponent from '@/components/admin/trainings/NewTrainingComponent'

export default {
  data: () => ({
    showNewTrainingDialog: false,
    trainingType: null,
    search: '',
    trainings: []
  }),

  methods: {
    toggleNewOrByTemplate (type = 'new') {
      this.trainingType = type
    },

    selectTraining (training) {
      delete training._id
      delete training.created_at
      training.save_into_model = false
      EventBus.$emit('loadTraining', training)
      this.toggleNewOrByTemplate('new')
    },

    loadTrainings () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      axios.get(`${API.userTrainings}?save_into_model=true`).then(response => {
        this.trainings = response.data.trainings
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar os treinos', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('showNewTrainingDialog')
  },

  mounted () {
    EventBus.$on('showNewTrainingDialog', data => {
      this.showNewTrainingDialog = data
      this.trainingType = null
      this.training = null
    })

    this.loadTrainings()
  },

  computed: {
    filteredTrainings () {
      return this.trainings.filter(training => {
        return training.name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },

  components: {
    'new-training': NewTrainingComponent
  },

  props: ['training', 'user']
}
</script>

<style scoped>
  .v-btn {
    min-width: auto;
  }

  .training-item {
    padding: 10px 15px;
  }

  .training-item:hover {
    background: #f0f0f0;
  }

  .training-list {
    max-height: 400px;
    overflow: hidden;
    overflow-y: auto;
  }

  table .v-input {
    max-width: 60px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/trainings/AdminNewTrainingDialog.vue